// extracted by mini-css-extract-plugin
export var mediaWrapper = "heroHeaderUrlBased-module--mediaWrapper--74fe6";
export var shadow = "heroHeaderUrlBased-module--shadow--4c075";
export var wrapper = "heroHeaderUrlBased-module--wrapper--136fd";